import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import { map, get, sortBy, filter, includes } from "lodash";
import Grid from "@material-ui/core/Grid";
import FormSection from "../../Common/FormSection";
import MultipleFormSection from "./MultipleFormSection";

import { getAttributeValue, getAttributeValues } from "../../../utils/profile";
import { getAttributeName } from "../../../utils/attributes";

import { LANGUAGES } from "../../../constants/common";

const styles = {
  sectionCol: {
    padding: "12px 24px 0",
    minWidth: "248px",
    maxWidth: "308px",
  },
};

const RailCarForm = (props) => {
  const {
    classes,
    section,
    data,
    lov,
    handleChange,
    validForm,
    errors,
    language,
    profileAttributes,
  } = props;
  const isValid = (id) => {  
    if (getAttributeValue(data, 18) && getAttributeValue(data, 283) && getAttributeValue(data, 89) && data['sys_tag_id'] && getAttributeValue(data, 50)) {
      validForm[18] = true
      validForm[283] = true
      validForm[89] = true
      validForm["ocrOrLpr"] = true
      validForm['sys_tag_id'] = true
      validForm.form = true
      return true
    }  else {
      validForm.form = false
    }
    if (validForm && validForm[id]) {
      return true;
    }
    return false;
  };

  if (section === "main") {
    const attributes = sortBy(
      filter(
        profileAttributes,
        (attr) => get(attr, ["active"]) && get(attr, ["app_display_main_page"])
      ),
      (attr) => get(attr, ["app_display_seq_numb"])
    );
    
    return (
      <>
        <Grid container style={{ marginTop: "-14px" }}>
          <Grid
            item
            xs={3}
            className={classes.sectionCol}
            style={{ paddingTop: "29px" }}
          >
            <Grid container direction="column">
              <FormSection
                formValue={[getAttributeValue(data, 18)]}
                setFormValue={handleChange}
                title2={getAttributeName(18)}
                id={18}
                options={{ required: true, redBorder: !isValid(18) }}
              />
               <FormSection
                formValue={[getAttributeValue(data, 287)]}
                setFormValue={handleChange}
                title2={getAttributeName(287)}
                id={287}
              />
              <FormSection
                formValue={[data.sys_tag_id]}
                setFormValue={handleChange}
                title="tag"
                id="sys_tag_id"
                type="select"
                options={{
                  required: true,
                  redBorder: !isValid("sys_tag_id"),
                  comboBox: true,
                  options:
                    lov.tag &&
                    lov.tag.map((t) => ({
                      id: t.id,
                      name: t["name_" + language],
                    })),
                }}
              />
            </Grid>
          </Grid>
          <Grid
            item
            xs={3}
            className={classes.sectionCol}
            style={{ paddingTop: "29px" }}
          >
            <Grid container direction="column">
              <FormSection
                formValue={[getAttributeValue(data, 89)]}
                setFormValue={handleChange}
                title2={getAttributeName(89)}
                id={89}
                type="select"
                options={{
                  required: true,
                  redBorder: !isValid(89),
                  comboBox: true,
                  options: map(
                    sortBy(get(lov, [89]), (t) => t[`name_${language}`]),
                    (t) => ({
                      id: t.id,
                      name: t[`name_${language}`],
                    })
                  ),
                }}
              />
               <FormSection
                formValue={[getAttributeValue(data, 283)]}
                setFormValue={handleChange}
                title2={getAttributeName(283)}
                id={283}
                type="select"
                options={{
                  required: true,
                  redBorder: !isValid(283),
                  options: lov[283].map((t) => ({
                    id: t.id,
                    name: t["name_" + language],
                  })),
                }}
              />
              {(getAttributeValue(data, 283)===181) &&
              <FormSection
                formValue={[getAttributeValue(data, 300)]}
                setFormValue={handleChange}
                title2={getAttributeName(300)}
                id={300}
                type="select"
                options={{
                  comboBox: true,
                  options: map(
                    sortBy(get(lov, [300]), (t) => t[`name_${language}`]),
                    (t) => ({
                      id: t.id,
                      name: t[`name_${language}`],
                    })
                  ),
                }}
              />
              }
              
            </Grid>
          </Grid>
          <Grid item xs>
            <Grid container direction="column">
              <Grid item>
                <Grid container>
                  <Grid
                    item
                    xs
                    className={classes.sectionCol}
                    style={{
                      paddingTop: "29px",
                      maxWidth: "unset",
                      minWidth: "unset",
                    }}
                  >
                    <MultipleFormSection
                      id={50}
                      typeId={135}
                      title2={getAttributeName(50)}
                      data={getAttributeValues(data, 50)}
                      setFormValue={handleChange}
                      lov={lov}
                      language={language}
                      errorMsg={errors[50]}
                      required={true}
                      checkbox={true}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container>
          {map(attributes, (attr) => {
            return [18, 283, 50, 287, 89,51,52,300].includes(attr.id) ? null : (
              <Grid
                item
                key={attr.id}
                xs={3}
                style={{
                  paddingBottom: "0",
                  padding: "10px 24px 0 24px",
                  minWidth: "248px",
                  maxWidth: "308px",
                }}
              >
                <Grid container direction="column">
                  <FormSection
                    formValue={[getAttributeValue(data, attr.id)]}
                    setFormValue={handleChange}
                    attribute={attr}
                    id={attr.id}
                    type={
                      includes(["radiobutton", "lov(picker)"], attr.data_type)
                        ? "select"
                        : attr.data_type === "boolean"
                        ? "boolean"
                        : "input"
                    }
                    options={{
                      redBorder: attr.required && !isValid(attr.id),
                      comboBox: attr.id === 89,
                      options: includes(
                        ["radiobutton", "lov(picker)"],
                        attr.data_type
                      )
                        ? map(
                            sortBy(lov[attr.id], (t) => t[`name_${language}`]),
                            (t) => ({
                              id: t.id,
                              name: t[`name_${language}`],
                            })
                          )
                        : null,
                    }}
                  />
                </Grid>
              </Grid>
            );
          })}
        </Grid>
      </>
    );
  }

  if (section === "secondary") {
    const attributes = sortBy(
      filter(
        profileAttributes,
        (attr) => get(attr, ["active"]) && !get(attr, ["app_display_main_page"])
      ),
      (attr) => get(attr, ["app_display_seq_numb"])
    );
    return (
      <>
        <Grid container>
          {map(attributes, (attr) => (
            <Grid
              item
              key={attr.id}
              xs={3}
              style={{
                paddingBottom: "0",
                padding: "10px 24px 0 24px",
                minWidth: "248px",
                maxWidth: "308px",
              }}
            >
              <Grid container direction="column">
                <FormSection
                  formValue={[getAttributeValue(data, attr.id)]}
                  setFormValue={handleChange}
                  attribute={attr}
                  id={attr.id}
                  type={
                    includes(["radiobutton", "lov(picker)"], attr.data_type)
                      ? "select"
                      : attr.data_type === "boolean"
                      ? "boolean"
                      : "input"
                  }
                  options={{
                    redBorder: attr.required && !isValid(attr.id),
                    comboBox: attr.id === 89,
                    options: includes(
                      ["radiobutton", "lov(picker)"],
                      attr.data_type
                    )
                      ? map(
                          sortBy(lov[attr.id], (t) => t[`name_${language}`]),
                          (t) => ({
                            id: t.id,
                            name: t[`name_${language}`],
                          })
                        )
                      : null,
                  }}
                />
              </Grid>
            </Grid>
          ))}
        </Grid>
      </>
    );
  }

  return null;
};

RailCarForm.propTypes = {
  profileType: PropTypes.oneOf([8]).isRequired,
  section: PropTypes.oneOf(["main", "secondary"]).isRequired,
  data: PropTypes.object.isRequired,
  lov: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  validForm: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  language: PropTypes.oneOf(LANGUAGES),
};

export default withStyles(styles)(RailCarForm);
